module.exports = __webpack_public_path__ + "static/media/DooPrimeColor.afdec70d.svg";